export default {"src":"/_next/static/media/skipper-paper.2d7826dd.svg","height":40,"width":40};